import './StickyContainer.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

/**
 * Represents a StickyContainer component
 *
 * @method
 * @param {StickyContainer} props - React properties passed from composition
 * @returns StickyContainer
 */
const StickyContainer = ( props ) => {

  const {
    children,
    position = 'bottom',
    zIndex = 2,
    fullWidth = false,
    fullHeight = false,
    customClassName
  } = props;

  const hasChildren = React.Children.toArray( children?.props?.children ).some(
    item => item === true || ( typeof item === 'object' && item !== null )
  );

  if( !hasChildren ){
    return null;
  }

  const containerClasses = classNames( 'StickyContainer', {
    [`${customClassName}`]: customClassName,
    [`StickyContainer--${position}`]: position,
    'StickyContainer--fullWidth': fullWidth,
    'StickyContainer--fullHeight': fullHeight
  } );
  return (
    <div
      className={ containerClasses }
      style={ { zIndex: zIndex } }
    >
      { children }
    </div>
  );
};


/**
 * @typedef {object} StickyContainerProps
 * @property {ReactNode} children - The content to be made sticky.
 * @property {('top'|'bottom'|'left'|'right')} [position='bottom'] - The position where the container should stick. Defaults to 'bottom'.
 * @property {number} [zIndex=100] - The z-index value for the sticky container. Defaults to 100.
 * @property {boolean} [fullWidth=false] - Whether the container should take the full width of its parent when sticky. Defaults to false.
 * @property {boolean} [fullHeight=false] - Whether the container should take the full height of its parent when sticky. Defaults to false.
 */

const propTypes = {
  children: PropTypes.node.isRequired,
  stickyClassName: PropTypes.string,
  position: PropTypes.oneOf( ['top', 'bottom', 'left', 'right'] ),
  zIndex: PropTypes.number,
  fullWidth: PropTypes.bool,
  fullHeight: PropTypes.bool
};

StickyContainer.propTypes = propTypes;

export default StickyContainer;
